package link.erpango.quip.core.auth.google

import link.erpango.quip.core.auth.google.GoogleAuthProvider

import link.erpango.quip.Quip
 
 actual val googleAuthProvider: GoogleAuthProvider 
    get() = Quip.appComponents.googleAuthProvider
